import N from 'utils-support/navigation'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { IRegionTag } from '@cbgms/api/modules/bank-holidays'

import { listRegionTags } from 'gms-support/src/app-support/regions/state/actions'

export const onAdd = () => {
  N.push('/regions/new')
}

export const onEdit = (data: { Region: IRegionTag }) => {
  N.push(`/regions/edit/${data.Region.UUID}`)
}

const RegionTagList = () => {
  return (
    <SupportListWrapper
      scope='bank-holidays'
      type='regions-list'
      onAdd={onAdd}
      onEdit={onEdit}
      loadAction={listRegionTags}
      translationKey='region_tag'
    />
  )
}

export default RegionTagList
